import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { startWith, map } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { AlertComponent } from '../alert/alert.component';
import { ConfirmDeleteComponent } from '../confirm-delete/confirm-delete.component';
import { ConfirmSaveComponent } from '../confirm-save/confirm-save.component';
import { DataService } from '../data.service';
import { DeleteComponent } from '../delete/delete.component';
import { FinalpopupComponent } from '../finalpopup/finalpopup.component';
import { HttpService } from '../http.service';
import { SavedialogComponent } from '../savedialog/savedialog.component';

@Component({
  selector: 'app-editdialog',
  templateUrl: './editdialog.component.html',
  styleUrls: ['./editdialog.component.scss']
})
export class EditdialogComponent implements OnInit {
  subhead: any;
  fromBuilder: any = new FormBuilder()
  priorityOrderList: any;
  secondpagelist: any;
  paymentModels: any;
  receiptTypes: any;
  transactionHead: any;
  transheadFee: any;
  transheadAkash: any;
  priorityNameOptions1: any;
  priorityNameOptions2: any;
  priorityNameOptions3: any;
  priorityNameOptions4: any;

  receiptTypesOptions: any;

  paymentModelsOptions: any;

  paymentModelsOptions2: any;

  paymentModelsOptions3: any;

  orglist: any;
  data: any;
  transheadcode: null;
  finalDiaplayName: null;
  finalCourseDisplay: null;
  finalHeadAmount: number;
  change: boolean;
  finalvalue: any;
  akashlist: any;
  payloadcoursefeelist: any;
  payloadakashbooks: any;
  addedlist: any;
  transheadId: any;
  orgId: any;
  orgsub: any;
  myGroup: any;
  akashcolor: string;
  akashcolor2: string;
  popupdisplay: string;
  headtypename: string;
  appprorityId: any;
  appsalesName: any;
  paymentpriority: any;
  paypriorityname: any;
  conscessionpriority: any;
  conName: any;
  deductionpriority: any;
  dedpriority: any;
  paymentcal: any;
  paymentdisplay: any;
  concessionmod: any;
  condisplay: any;
  deductionmod: any;
  deductdisplay: any;
  reiciettype: any;
  recietdisplay: any;
  previousfee: number;
  payload: any;
  coursefeeID: any;
  finalacademyyear: any;
  finalbatch: any;
  finalorient: any;
  finalorg: any;
  finalcoachingtype: any;
  finalprogram: any;
  saveheaddata: any;
  app: any;
  whethereditOrnot: any;
  details: any;
  finalpromtingCourseTrack: any;
  academicId: any;
  batchId: any;
  orientationtype: any;
  coachintype: any;
  programId: any;
  coursefeeheadid: any;
  taxInPaid: any=0;
  taxOnNetFee: any=0;
  status: any;
  verificationsubheadlist: { name: string; check: any; }[];
  headDisplayList: string;
  headcontainerborder: string;
  hrdispaly: string;
  maincontainerborder1: string;
  submitbuttondiv: string;
  isdisabled: boolean;
  btndisplay: string;
  listtype: any;
  Akashheadcontainerborder: string;
  isdisabled2: boolean;
  btndisplay2: string;
  model: any;
  receipt: any;
  amount: any;
  amountsum: number;
  amountsum2: number;
  totalsum: number;
  length: any;
  taxvalue: any="No Tax";
  object: any;
  stateGstRate: any=0.0;
  centralGstRate: any=0.0;
  totalGstRate: any=0.0;
  organisationOptions2: any;
  headOptions: any;
  appSales: FormControl<any>;
  priority: FormControl<any>;
  conPriority: FormControl<any>;
  deductPriority: FormControl<any>;
  headCalculationType: FormControl<any>;
  deductCalculationType: FormControl<any>;
  conHeadCalculationType: FormControl<any>;
  receiptsType: FormControl<any>;
  headControl: FormControl<any>;
  organisationcontrol: FormControl<any>;
  newItem: any;
  newlistitem:any;
  headcode: any;
  constructor(private http: HttpService, @Inject(MAT_DIALOG_DATA) public data1: any,
    private dialogRef: MatDialogRef<EditdialogComponent>, private dialog: MatDialog, private dtservice: DataService
  ) { }
  ngOnInit(): void {
    this.secondpagelist = this.data1.secondpagelist
    this.orglist = this.data1.orglist
    this.data = this.data1.data
    this.addedlist=this.data1.addedList
   this.transheadId=this.data.tranHeadId
   this.orgsub=this.data.orgSub
   this.transheadcode=this.data.subTransCode
   this.headcode=this.data.headCode
    this.subhead = this.fromBuilder.group({
      headAmount: [this.data.headAmount, Validators.required],
      subTransCode: [this.data.subTransCode, Validators.required],
      appFee: [this.getappFee(this.data.appFee), Validators.required],
      taxInPaid: [this.data.taxInPaid, Validators.required],
      taxOnNetFee: [this.data.taxOnNetFee, Validators.required],
      allowAdditionalAmount: [this.getappFee(this.data.allowAdditionalAmount), Validators.required],
      allowExcessAmount: [this.getappFee(this.data.allowExcessAmount), Validators.required],
      appSales2: [this.data.appSales, Validators.required],
      priority2: [this.data.conPayments, Validators.required],
      conPriority2: [this.data.conPriority, Validators.required],
      deductPriority2: [this.data.deductPriority, Validators.required],
      headCalculationType2: [this.getpriorityOptions(this.data.paymentModel), Validators.required],
      deductCalculationType2: [this.getpriorityOptions(this.data.deductionModel), Validators.required],
      conHeadCalculationType2: [this.getpriorityOptions(this.data.concessionModel), Validators.required],
      receiptsType2: [this.getDisplayName(this.data.receiptsType), Validators.required],
      displayName: [this.data.displayName, Validators.required],
      courseDisplay: [this.data.courseDisplay, Validators.required],
      headControl2: [this.data.tranHeadId, Validators.required],
      organisationControl2: [this.data1.orgId, Validators.required],
    });
    this.appSales = new FormControl();
    this.priority = new FormControl();
    this.conPriority = new FormControl();
    this.deductPriority = new FormControl();
    this.headCalculationType = new FormControl();
    this.deductCalculationType = new FormControl();
    this.conHeadCalculationType = new FormControl();
    this.receiptsType = new FormControl();
    this.headControl = new FormControl();
    this.organisationcontrol = new FormControl();
    this.getheadList(this.data1.headDisplayList)
    this.getorgList(this.orglist)
    this.getapidata()

  }
  getheadList(headlist:any)
  {
    this.headOptions=this.headControl.valueChanges.pipe(
        startWith(''),
        map((value:string)=>this.Filter(value,headlist,'headName' || ''))
      
    )
  }
  getorgList(orglist:any)
  {
    this.organisationOptions2=this.organisationcontrol.valueChanges.pipe(
      startWith(''),
      map((value:string)=>this.Filter(value,orglist,'orgName' || ''))
    
  )
  }
  getDisplayName(value:any)
  {
    if(value=="BY_PRE_PRINTED_RECEIPT")
      {
        return "By Pre Printed Receipt"
      }
      else {
        return "By SMS"
      }
  }
  getpriorityOptions(value:any)
  {
     if(value =="Flat")
      {
         return 0
      }
      else {
         return 1
      }
  }
  getappFee(value:any)
  {
    if(value==1)
      {
        return "option1"
      }
      else {
        return "option2"
      }
  }

  getapidata() {

    this.priorityOrderList = this.secondpagelist.priorityOrderList;
    this.paymentModels = this.secondpagelist.paymentModels;
    this.receiptTypes = this.secondpagelist.receiptTypes;
    this.transactionHead = this.secondpagelist.transactionHeadsList;
    this.transheadFee = this.transactionHead[0].transactionHeads;
    this.transheadAkash = this.transactionHead[1].transactionHeads;
    this.priorityNameOptions1 = this.appSales.valueChanges.pipe(
      startWith(''),
      map((value: string) => this.Filter(value, this.priorityOrderList, 'priorityName' || ''))
    )
    this.priorityNameOptions2 = this.conPriority.valueChanges.pipe(
      startWith(''),
      map((value: string) => this.Filter(value, this.priorityOrderList, 'priorityName' || ''))
    )
    this.priorityNameOptions3 = this.deductPriority.valueChanges.pipe(
      startWith(''),
      map((value: string) => this.Filter(value, this.priorityOrderList, 'priorityName' || ''))
    )
    this.priorityNameOptions4 = this.priority.valueChanges.pipe(
      startWith(''),
      map((value: string) => this.Filter(value, this.priorityOrderList, 'priorityName' || ''))
    )

    this.receiptTypesOptions = this.receiptsType.valueChanges.pipe(
      startWith(''),
      map((value: string) => this.Filter(value, this.receiptTypes, 'displayName' || ''))
    )
    this.paymentModelsOptions = this.headCalculationType.valueChanges.pipe(
      startWith(''),
      map((value: string) => this.Filter(value, this.paymentModels, 'displayName' || ''))
    )
    this.paymentModelsOptions2 = this.conHeadCalculationType.valueChanges.pipe(
      startWith(''),
      map((value: string) => this.Filter(value, this.paymentModels, 'displayName' || ''))
    )
    this.paymentModelsOptions3 = this.deductCalculationType.valueChanges.pipe(
      startWith(''),
      map((value: string) => this.Filter(value, this.paymentModels, 'displayName' || ''))
    )

  }
  private Filter(value: string, list: any[], name: any): any[] {
    const searchValue = value.trim().toLocaleLowerCase();
    let filteredList = list.filter((item: any) => item[name] && item[name].toString().trim().toLocaleLowerCase().includes(searchValue));
    return filteredList;
  }



  closepopup() {

    const data = {     
      newdata:this.newItem,
      listdata:this.newlistitem
    }
    this.dialogRef.close(data)
  }
  lists(arg0: string, lists: any) {
    throw new Error('Method not implemented.');
  }
  headCode(value: any) {
    this.transheadId = value.transHeadId;
    this.transheadcode = value.headName;
    this.addedlist.push(this.transheadId)
    this.headcode=value.headCode
  }
  getboolean(value: any) {
    if (value == 'option1') {
      return 1
    }
    else {
      return 0;
    }
  }
  
  verifyheadtwo() {
    if (this.myGroup.get('akashdata').value == null) {
      this.akashcolor = 'red'
      this.akashcolor2 = 'red !important';
    }
    else {
      this.popupdisplay = 'flex';
      this.headtypename = 'AKASH '
    }
  }
  verify(item: any) {
    if (item == null) {
      return false;
    }
    else {
      return true;
    }
  }
  getpaymentModels(value:any)
  {
    if(value==0)
      {
        return "FLAT"
      }
      else {
        return "PROPORTIONAL_ON_TOTAL_DUE"
      }
  }
  getreciept(value:any)
  {
     if(value=="By Pre Printed Receipt")
      {
        return "BY_PRE_PRINTED_RECEIPT"
      }
      else {
        return "BY_SMS"
      }
  }
  getyesorno(value:any)
  {
       if(value== "option2")
        {
          return 0
        }
        else {
          return 1
        }
  }
  verifysubhead() {
    this.verificationsubheadlist = [
      {
        'name': 'Sub Head Code',
        'check': this.transheadcode
      },
      {
        'name': 'Head Amount',
        'check': this.subhead.get("headAmount").value
      },
      {
        'name': 'Display Name',
        'check':this.subhead.get("displayName").value
      },
      {
        'name': 'Course Display',
        'check': this.subhead.get("courseDisplay").value,
      }
    ]
    let datacheck = false;
    for (let i = 0; i < this.verificationsubheadlist.length; i++) {
      datacheck = this.verify(this.verificationsubheadlist[i].check)
      if (!datacheck) {
        //  window.alert('Please Select '+this.verificationsubheadlist[i].name)
        const data = "Please Enter " + this.verificationsubheadlist[i].name
        this.dialog.open(AlertComponent, {
          width: '800px',
          position: { top: '10px', right: '10px' },
          data: { data }
        });
        break;
      }
    }
      this.closepopup();
  
  }
  tax(value: any) {
    this.taxvalue = value;
    if (value == 'taxInclusive') {
      this.http.getTax(this.dtservice.campusId, this.orgId, this.transheadId).subscribe((res: any) => {
        this.stateGstRate = res.stateGstRate;
        this.centralGstRate = res.centralGstRate;
        this.totalGstRate = res.totalGstRate;
      });
      this.taxOnNetFee = 1
      this.taxInPaid = 0
    }
    else if (value == 'taxExclusive') {
      this.http.getTax(this.dtservice.campusId, this.orgId, this.transheadId).subscribe((res: any) => {
        this.stateGstRate = res.stateGstRate;
        this.centralGstRate = res.centralGstRate;
        this.totalGstRate = res.totalGstRate;
      });
      this.taxOnNetFee = 0
      this.taxInPaid = 1
    }
    else {
      this.taxOnNetFee = 0
      this.taxInPaid = 0
    }
  }
  close() {
    this.closepopup()
  }
  getSum() {
    this.amountsum = 0;
    this.amountsum2 = 0;
    this.totalsum = 0;
    this.length = this.lists.length + this.akashlist.length;
    for (let i = 0; i < this.lists.length; i++) {
      this.amountsum = this.amountsum
    }
    for (let i = 0; i < this.akashlist.length; i++) {
      this.amountsum2 = this.amountsum2 + Number(this.akashlist[i].headAmount)
    }
    this.totalsum = this.amountsum + this.amountsum2;
  }
  org(value:any)
  {
    this.orgId=value.orgId
    this.orgsub=value.orgShortName
  }
  save(): void {
    const dialogref = this.dialog.open(SavedialogComponent, {
      id: 'save'
    })
    dialogref.afterClosed().subscribe(deleteResult => {

      if (deleteResult) {
         this.newItem = {
          "courseFeeHeadId":this.data.courseFeeHeadId,
          "tranHeadId": this.subhead.get("headControl2").value,
          "headAmount": this.subhead.get("headAmount").value,
          "subTransCode":  this.transheadcode,
          "paymentModel": this.getpaymentModels(this.subhead.get("headCalculationType2").value),
          "concessionModel": this.getpaymentModels(this.subhead.get("conHeadCalculationType2").value),
          "deductionModel":this.getpaymentModels(this.subhead.get("deductCalculationType2").value),
          "appFee":this.getyesorno(this.subhead.get("appFee").value),
          "allowAdditionalAmount":this.getyesorno(this.subhead.get("allowAdditionalAmount").value),
          "allowExcessAmount": this.getyesorno(this.subhead.get("allowExcessAmount").value),
          "taxInPaid": this.taxInPaid,
          "taxOnNetFee": this.taxOnNetFee,
          "appSales": this.subhead.get("appSales2").value,
          "conPayments": this.subhead.get("priority2").value,
          "conPriority": this.subhead.get("conPriority2").value,
          "deductPriority":this.subhead.get("deductPriority2").value,
          "displayName": this.subhead.get("displayName").value,
          "courseDisplay": this.subhead.get("courseDisplay").value,
          "receiptsType":this.getreciept(this.subhead.get("receiptsType2").value),
          "status": true
        };
        this.newlistitem = {
          "courseFeeHeadId":this.data.courseFeeHeadId,
          "tranHeadId": this.subhead.get("headControl2").value,
          "headAmount": this.subhead.get("headAmount").value,
          "subTransCode": this.transheadcode,
          "orgId": this.subhead.get("organisationControl2").value,
          "orgShortName": this.orgsub,
          "displayPaymentModel": this.getpaymentModels(this.subhead.get("headCalculationType2").value),
          "displayConcessionModel": this.getpaymentModels(this.subhead.get("conHeadCalculationType2").value),
          "displayDeductionModel":this.getpaymentModels(this.subhead.get("deductCalculationType2").value),
          "displayappFee":this.getyesorno(this.subhead.get("appFee").value),
          "allowAdditionalAmount":this.getyesorno(this.subhead.get("allowAdditionalAmount").value),
          "allowExcessAmount": this.getyesorno(this.subhead.get("allowExcessAmount").value),
          "headCode":this.headcode,
          "taxType":this.taxvalue,
          "appSales": this.subhead.get("appSales2").value,
          "conPayments": this.subhead.get("priority2").value,
          "conPriority": this.subhead.get("conPriority2").value,
          "deductPriority":this.subhead.get("deductPriority2").value,
          "displayName": this.subhead.get("displayName").value,
          "courseDisplay": this.subhead.get("courseDisplay").value,
          "displatReceiptType":this.subhead.get("receiptsType2").value,
          "status": true
        };
        this.verifysubhead()
        dialogref.close();
        this.dialog.open(ConfirmSaveComponent, {
          id: "savedialog",
        })
      }
    });
  }
}  